import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { Maintenance, Operation, Resource } from './reference';
import { Flight } from '../communication-module-data/reference';
import { SettingsService } from '@core/services/settings/settings.service';

@Injectable({
  providedIn: 'root'
})
export class WorkflowModuleRestApiService {
	private apiWorkflowUrl: string;
	private apiTechProcessesUrl: string;

  constructor(private http: HttpClient, private settingsService: SettingsService) {
    settingsService.general.applicationConfig$.subscribe(config => {
			this.apiWorkflowUrl = config.apiWeightBalanceURL;
			this.apiTechProcessesUrl = config.apiTechProcessesURL;
		});
  }

  // Http Options
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  getFlights(): Observable<Flight[]> {
    return this.http.get<Flight[]>(this.apiWorkflowUrl + '/flights')
    .pipe(
      retry(1),
      catchError(this.handleError)
    );
  }

  async getOperations(id): Promise<Operation[]> {
    return this.http.get<Operation[]>(this.apiWorkflowUrl + '/flights/' + id + '/operations')
    .pipe(
      retry(1),
      catchError(this.handleError)
    ).toPromise();
  }

  addOperation(id, operation) {
    return this.http.post<Operation>(this.apiTechProcessesUrl + '/flights/' + id + '/operations',
                                     JSON.stringify(operation),
                                     this.httpOptions)
    .pipe(
      retry(1),
      catchError(this.handleError)
    )
  }

  getMaintenances(): Observable<Maintenance[]> {
    return this.http.get<Maintenance[]>(this.apiWorkflowUrl +
                                        '/maintenance')
    .pipe(
      retry(1),
      catchError(this.handleError)
    );
  }

  getMaintenance(id): Observable<Maintenance> {
    return this.http.get<Maintenance>(this.apiWorkflowUrl +
                                   '/maintenance/' +
                                   id)
    .pipe(
      retry(1),
      catchError(this.handleError)
    );
  }

  updateMaintenance(id: number, data: Maintenance): Observable<Maintenance> {
    return this.http.put<Maintenance>(this.apiTechProcessesUrl
                                          + '/maintenance/' + id,
                                          JSON.stringify(data), this.httpOptions)
    .pipe(
      retry(1),
      catchError(this.handleError)
    );
  }

  // Operations
  getReferenceOperations(): Observable<Operation[]> {
    return this.http.get<Operation[]>(this.apiTechProcessesUrl + '/admin/operations')
    .pipe(
      retry(1),
      catchError(this.handleError)
    );
  }

  // Resource
  getReferenceResources(): Observable<Resource[]> {
    return this.http.get<Resource[]>(this.apiTechProcessesUrl + '/admin/resources')
    .pipe(
      retry(1),
      catchError(this.handleError)
    );
  }

  // Error handling
  handleError(error) {
     let errorMessage = '';
     if (error.error instanceof ErrorEvent) {
       // Get client-side error
       errorMessage = error.error.message;
     } else {
       // Get server-side error
       errorMessage = 'Error Code: ${error.status}\nMessage: ${error.message}';
     }
     window.alert(errorMessage);
     return throwError(errorMessage);
  }
}
